<template>
  
    <div class="hoursOrder">
       <headers :title="'钟点保洁预约'"/>
   
        
             <!-- 地址栏 -->
          <div class="addressOut" @click="changeAddress">
                 <div class="addressContent">
                     <div class="namePhone">
                         <div class="name">{{Address.guestName}}</div>
                         <div class="phone">{{Address.guestPhone}}</div>
                         <div class="acreage" v-if="Address.Acreage">{{Address.Acreage}}㎡</div>
                     </div>
                     <div class="address">
                        {{Address.guestAddress}}
                     </div>
                 </div>
                 <div class="addressRight">
                     <span class="iconfont iconyoujiantou"></span>
                 </div>
          </div>
           <!-- 选择按钮 -->
             <div class="select">
                 <div class="selectOut" v-for="(item,index) in PriceArr" :key="index">
                    <div class="select-one" :class="{on:index == showButtonIndex}" @click="selectButton(index)" ><p>{{item.ItemName}}</p><p>{{item.ItemPrice}}{{item.ItemUnit}}</p></div>
                 </div>
                 
             </div>
           <!-- 建议时长 -->
           <div class="orderImg">
               <img :src="ServiceFlowPicture.Url" alt="">
           </div>
           <!-- 选择时间 -->
            <div class="dateOut">
                <div class="title">请选择服务时间</div>
                <div class="date">
                     <Calendar
                     v-on:choseDay="clickDay"
                     :agoDayHide='agoDay' ref="calendar" :calendarIndex='calendarIndex'></Calendar>
                </div> 
                
               
                <div class="timeTable">
                    <div class="tableTitle">
                        <div>日期</div>
                        <div>开始时间</div>
                        <div>结束时间</div>
                        <div>时长</div>
                    </div>
                    <div class="tableContent" v-show="duration">
                        <div>{{day}}</div>
                        <div>{{startTime}}</div>
                        <div>{{endTime}}</div>
                        <div>{{duration}}小时</div>
                    </div>
                </div>
                <van-cell-group>
                    <van-field
                        v-model="message"
                        label="备注"
                        type="textarea"
                        placeholder="请输入留言"
                        rows="1"
                        autosize
                    />
                </van-cell-group>
                <div class="price">
                   <p>合计</p>
                   <p class="jiage">￥{{price ? price : 0}}元</p>
                </div>
            </div>
     
        <!-- 脚步导航 -->
        <div class="foot">
          <div class="kf"><a href="tel:4001500600">客服</a></div>
          <div class="confirm" @click="confirmOrder">修改订单</div>
        </div>
         
         <van-popup v-model="isShowPicker" position="bottom" :overlay="true" @click-overlay="closePicker">
                  <van-picker :columns="columns" show-toolbar title="请选择服务时间" @cancel="onCancel" @confirm="onConfirm" v-if="isShowPicker"/>
         </van-popup>
    </div>
  
</template>

<script>
import {mapState} from 'vuex'
import Calendar from '../../components/Calendar/index.js'
import dayjs from 'dayjs'
import { Toast } from 'vant'
import { parseTime } from "../../util/common-fun.js";
export default {
    data () {
      return {
          showButtonIndex: 0,
          agoDay: null,
          isShowPicker: false,
          message:'',
          columns: [
        {
          values:["07:00","07:30","08:00","08:30","09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00"],
          defaultIndex:0
        },
        {
          values: ["10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00","17:30","18:00","18:30","19:00","19:30","20:00","20:30","21:00","21:30","22:00"],
          defaultIndex:0
        }
      ],
      newday:'',
      day:'',//日期
      calendarIndex:[],
      startTime: '',
      endTime: '',
      duration: '', // 时长
      hoursPrice: 0, // 单价
      ServiceFlowPicture: {},
      PriceArr:[],
      PriceOne:{},
      PriceTwo:{},
      Address:{},
      ContentId: null,
      ServiceId: null,
      ContentType: '',
      OrderId: null,
      isConfirmOrder: false,
      }
    },
    computed: {
      ...mapState(['orderAddress']),
        price () {
          return this.hoursPrice * this.duration
        }
    },
    beforeRouteEnter(to, from, next) {
      
      if(from.name === 'AddressList') { //判断是从哪个路由过来的
          to.meta.isBack = true;
      }
      next();
    },
    created () {
     //  this.getData()
      
    },
     mounted(){
      this.initCalendar()
       this.getData() 
    },
    /* activated(){
          if (this.orderAddress.length > 0) {
             this.Address = this.orderAddress[0]
          }  

           if(!this.$route.meta.isBack) {  // 不是后退，重新拿数据
             this.showButtonIndex = 0
             this.day = ''
             this.startTime = ''
             this.endTime = ''
             this.duration = ''
             this.hoursPrice = 0
             this.message = ''
             this.getData()
             this.$refs.calendar.historyChose = []
            }
            this.$route.meta.isBack = false

    }, */
    methods: {
        // 配置日历
        initCalendar(){
          let day = parseTime(new Date(), "{y}/{m}/{d}");
          let flag = this.isDuringDate(day + " " + "00:00", day + " " + "18:00");
          let curDate = new Date()
          let preDate = null
          if (flag) {
            preDate = (curDate.getTime()).toString().substr(0,10)
          }else{
            preDate = (curDate.getTime() + 24*60*60*1000).toString().substr(0,10)
          } 
          this.agoDay = preDate
        },
        //判断当前时间是否处于某个一个时间段内
        isDuringDate(beginDateStr, endDateStr) {
          var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
          if (curDate >= beginDate && curDate <= endDate) {
            return true;
          }
          return false;
        },
        getData () {

            // 发送请求
            
              // 获取订单信息
             this.$axios.get('/api/DjOrder/GetOrderInfo',{
                params: {
                  Id: this.$route.query.Id
                }
            }).then(res => {
              let data = res.data
               let ContentInfoData = data.ContentInfo
               if (process.env.NODE_ENV === "development"){
                  this.ServiceFlowPicture = JSON.parse(ContentInfoData.Pictures).ServiceFlowPicture.map((i) => {
                      i.Url = 'http://www.lungchuenjz.cn' + i.Url
                      return i
                  })[0]
               }else{
                  this.ServiceFlowPicture = JSON.parse(ContentInfoData.Pictures).ServiceFlowPicture[0]
               }
                 

                   this.PriceArr = JSON.parse(ContentInfoData.PriceJson)
                  //this.PriceOne = JSON.parse(ContentInfoData.PriceJson)[0]
                  //this.PriceTwo = JSON.parse(ContentInfoData.PriceJson)[1]

                  this.hoursPrice = Number(this.PriceArr[0].ItemPrice)
                  this.ContentId = ContentInfoData.ContentId
                  this.ServiceId = ContentInfoData.ServiceId
                  this.ContentType = ContentInfoData.ContentType

              // OrderId
              this.OrderId = data.OrderId
              
               // 地址信息
              this.Address.guestName = data.CustomerName
              this.Address.guestPhone = data.CustomerPhone
              this.Address.guestAddress = data.CustomerAddress
              this.Address.address0 = data.Add0
              this.Address.address1 = data.Add1
              this.Address.address2 = data.Add2
              this.Address.Acreage = data.Acreage
               // 备注
               this.message = data.CustomerRemarks
               // 规则
               let ServiceRule = JSON.parse(data.ServiceRule)
               this.hoursPrice = ServiceRule.ServicePrice
              // console.log(ServiceRule)
               /* if (ServiceRule.ServicePrice == 30) {
                      this.showButtonOne = true
                      this.showButtonTwo =false
               }else if(ServiceRule.ServicePrice == 35) {
                       this.showButtonOne = false
                      this.showButtonTwo = true
               } */
               this.PriceArr.forEach((item,index) => {
                 if (ServiceRule.ServicePrice == item.ItemPrice) {
                       this.showButtonIndex = index
                 }
               })
              this.day = ServiceRule.FirstServiceDate.split(" ")[0]
              this.startTime = ServiceRule.FirstServiceTime
              this.endTime = ServiceRule.FirstServiceTimeEnd
              this.duration = ServiceRule.TimeLong
              if (!this.$route.meta.isBack){
                  this.$refs.calendar.list.forEach((item,index) => {
                  if(this.day.split('-')[2] == item.date.split('/')[2] && this.day.split('-')[1].replace(/\b(0+)/gi,'') == item.date.split('/')[1]){
                    this.calendarIndex=[]
                    this.calendarIndex.push(this.day.split('-')[1].replace(/\b(0+)/gi,''))
                    this.calendarIndex.push(index)
                  }
                  item.chooseDay = false
                  if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
                    item.chooseDay = true
                  }
              })
              }

              if (this.$route.meta.isBack){ // 选地址后 后退的数据
                if (this.orderAddress.length > 0) {
                  this.Address = this.orderAddress[0]
                } 
                let hoursObj = JSON.parse(localStorage.getItem('hoursEditObj'))
                this.day = hoursObj.day
                this.startTime = hoursObj.startTime,
                this.endTime = hoursObj.endTime,
                this.duration = hoursObj.duration,
                this.message = hoursObj.message
                this.hoursPrice = hoursObj.hoursPrice
                this.PriceArr.forEach((item,index) => {
                        if (item.ItemPrice == this.hoursPrice) {
                              this.showButtonIndex = index
                        }
                  })
              this.$refs.calendar.list.forEach((item,index) => {
                    if(this.day.split('-')[2] == item.date.split('/')[2] && this.day.split('-')[1].replace(/\b(0+)/gi,'') == item.date.split('/')[1]){
                      this.calendarIndex=[]
                      this.calendarIndex.push(this.day.split('-')[1].replace(/\b(0+)/gi,''))
                      this.calendarIndex.push(index)
                    }
                    item.chooseDay = false
                    if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
                      item.chooseDay = true
                    }
                })
                  localStorage.removeItem('hoursEditObj')
            }
              

            })

            
            
            
       
        },
        clickDay(data) {
         // console.log(data); //选中某天
          this.isShowPicker = !this.isShowPicker
          this.newday = data.replace(/\//g, "-")
        },
        onConfirm(value, index) {
           
                let startTime = value[0]
                let endTime = value[1]
                const nData = new Date()
                const year = nData.getFullYear()
                const month = nData.getMonth() + 1
                const day = nData.getDay()
                const nStartTime = year + '-' + month + '-' + day + ' ' + startTime
                const nEbdTime = year + '-' + month + '-' + day + ' ' + endTime
                const date1 = dayjs(nStartTime)
                const date2 = dayjs(nEbdTime)
                
                let difference = date2.diff(date1, 'hours',true)
                  
                  if (difference < 3) {
                      Toast('开始与结束时间间隔最少3小时');
                  }else{
                      this.startTime = startTime
                      this.endTime = endTime
                      this.duration = difference
                      this.isShowPicker = false

                      this.day = this.newday
                      this.$refs.calendar.list.forEach((item,index) => {
                          if(this.day.split('-')[2] == item.date.split('/')[2] && this.day.split('-')[1] == item.date.split('/')[1]){
                          this.calendarIndex=[]
                          this.calendarIndex.push(this.day.split('-')[1])
                          this.calendarIndex.push(index)
                          }
                        })
                  }
            
             
            

        },
        onCancel() {
           this.$refs.calendar.historyChose = []
           this.isShowPicker = false
           this.$refs.calendar.list.forEach((item,index) => {
             
               item.chooseDay = false
               if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
               item.chooseDay = true
             }
           })
        },
        closePicker () {
           this.$refs.calendar.historyChose = []
           this.$refs.calendar.list.forEach((item,index) => {
             
               item.chooseDay = false
               if(this.calendarIndex[1] == index && item.date.split('/')[1] == this.calendarIndex[0]){
               item.chooseDay = true
             }
           })
        },
        selectButton (index) {
         this.showButtonIndex = index
          let price = Number(this.PriceArr[index].ItemPrice)
          this.hoursPrice = price
         
        },
        
        changeAddress () {
          let _this = this
          let hoursObj = {
            startTime:_this.startTime,
            endTime: _this.endTime,
            duration: _this.duration,
            day:_this.day,
            message:_this.message,
            hoursPrice:_this.hoursPrice
          }
          localStorage.setItem('hoursEditObj', JSON.stringify(hoursObj))
          this.$router.push('/addresslist')
        },
        confirmOrder () {
          
          if (!this.Address) {
            Toast('请输入有效地址信息！');
            return
            }

          if (this.duration == '') {
             Toast('请选择服务日期！');
          }else {
           
            let ServiceRule = JSON.stringify({
              ServicePrice: this.hoursPrice,
              TimeLong: this.duration,
              FirstServiceDate: this.day,
              FirstServiceTime: this.startTime,
              FirstServiceTimeEnd: this.endTime,
              CustomerRemarks: this.message
            })

           if(!this.isConfirmOrder){
              this.isConfirmOrder = true

               // 修改订单
            this.$axios.post('/api/DjOrder/EditOrder',{
              OrderId: this.OrderId,
              CustomerName: this.Address.guestName,
              CustomerPhone: this.Address.guestPhone,
              CustomerAddress: this.Address.guestAddress,
              Add0: this.Address.address0,
              Add1: this.Address.address1,
              Add2: this.Address.address2,
              Acreage: this.Address.Acreage,
              CustomerRemarks: this.message,
              OrderFlag: this.ContentType,
              ContentId: this.ContentId,
              ServiceId: this.ServiceId,
              ServicePrice: this.hoursPrice,
              ServiceUnit: this.PriceArr[0].ItemUnit,
              ServiceQty: this.duration,
              ServiceRule
            }).then(res => {
              // console.log(res)
              if (res.data.type == 1 ) { 
                Toast.success({
                  message: '成功修改订单',
                  duration: 500
                })
                this.isConfirmOrder = false
                this.$router.push('/orderlist')
               }else{
                 this.isConfirmOrder = false
                 Toast(res.data.message);
               }
            }).catch(() => {
              this.isConfirmOrder = false
              Toast('提交失败，请重新提交！');
            })

            }
           
            
          }
        }
   
    },
     components: {
        Calendar
    }
    
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.hoursOrder
  background: rgb(240, 240, 240)
  height: 100%
  .addressOut
    width: 100%
    height: 80px
    margin-top: 45px
    background: #f7f4e4
    position: relative
    display: flex
    justify-content: center
    align-items: center
    font-size: 14px
    color: #6b6b6b
    &::before
     content:''
     position:absolute
     top:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")   
    &::after
     content:''
     position:absolute
     bottom:0
     width:100%
     height:4px
     background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAAAKBAMAAACOO0tGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAnUExURf///4u16Oxtbezz/J3B7NDh9vvd3fSmprjS8vGNje57e/jDw/7w8IQ3dnAAAABSSURBVCjPY2CAAG4l7GADVJ4hUBArEIXJJ2HXrw6TZ8auX7ABKs+zCLsBE2AGmGDXLwKT58SuX+sATIEjdgOcYfJF2A1Qg8lz4PCBwWgQUiMIAWCaOFG2MdFRAAAAAElFTkSuQmCC")
    .addressContent
      height: 100%
      width: 90%
      margin-left: -2px
      display: flex
      flex-direction: column
      justify-content: center
      padding: 5px
      .namePhone
        display: flex
        margin-bottom: 12px
        .name
          margin-right: 12px
        .phone
          margin-right: 64px
    .addressRight
      &>span
        font-size: 28px
  .select
    width: 100%
    background:white
    margin-top: 10px
    display: flex
    flex-wrap: wrap
    justify-content: center
    align-items: center
    padding: 18px 12px
    box-sizing: border-box
    .selectOut
      width: 50%
      margin-bottom: 6px
      .select-one
        padding: 2px
        box-sizing: border-box
        height: 46px
        width: 90%
        border: 1px solid #eee
        display: flex
        font-size: 14px
        flex-direction: column
        justify-content: center
        align-items: center
        border-radius: 8px
        margin: auto
        position: relative
        overflow: hidden
        &.on
          border: 1px solid green
          color: green
          &::after
            content: "";
            width: 0;
            height: 0;
            position: absolute;
            right: 0px;
            bottom: 0px;
            border-bottom: 18px solid #009933;
            border-left: 18px solid transparent;
  .orderImg
    width: 100%
    border-top: 1px solid #eee
    border-bottom: 1px solid #eee
    background: white
    &>img
     width: 100%
  .dateOut
     width: 100%
     background: white
     border-bottom: 1px solid #eee
     .title
       width: 90%
       margin-top: 6px
       padding: 10px
       font-size: 14px
       color: #333
     .date
       width: 100%
       margin: auto
       border-top: 1px solid #eee
       border-bottom: 1px solid #eee
       &>>>.wh_container
         max-width: 100%
         .wh_content_all
          background-color: white
          & .wh_jiantou1
            border-top: 2px solid #009933;
            border-left: 2px solid #009933;
          & .wh_jiantou2
            border-top: 2px solid #009933;
            border-right: 2px solid #009933;
          & .wh_content_li
            color: #009933
          & .wh_item_date
            color: #009933
            background-color: white
          & .wh_item_date.wh_chose_day
            background-color: #009933;color: white
          & .wh_item_date.wh_want_dayhide
            color: #bfbfbf
          & .wh_item_date.wh_other_dayhide
            color: #bfbfbf
     .timeTable
       width: 98%
       margin: 5px auto
       display: flex
       flex-direction: column
       background: white
       font-size: 14px
       .tableTitle
         display: flex
         &>div
          width: 25%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-right: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
       .tableContent
         display: flex
         &>div
          width: 25%
          display: flex
          justify-content: center
          align-items: center
          border: 1px solid #bfbfbf
          border-right: none
          border-top: none
          height: 30px
          &:last-child
           border-right: 1px solid #bfbfbf
     .price
       display: flex
       justify-content: space-between
       height: 40px
       align-items: center
       margin-bottom: 42px
       background: white
       &>p
        font-size: 14px
        margin-left: 14px
       .jiage
         color: red
         margin-right: 6px
  .foot
    width: 100%
    height: 40px
    position: fixed
    left: 0
    right: 0
    bottom: 0
    display: flex
    .confirm
      width: 70%
      height: 100%
      background: #c21a1a
      text-align: center
      line-height: 40px
      color: white
    .kf
      width: 30%
      height: 100%
      background: #009933
      text-align: center
      line-height: 40px
      color: white
      & a
        color white
        display: inline-block
        width 100%
        height 100%
        display flex
        align-items center
        justify-content center


    
       

    
</style>



// WEBPACK FOOTER //
// src/pages/OrderEdit/HoursOrderEdit.vue